import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function TitleEdit() {
    const { t } = useTranslation('cards');

    return (
        <CardEditForm title={t('TitleEdit.title')}>
            {() => (
                <>
                    <TextField
                        name="profile.fullname"
                        placeholder={t('profileEdit.placeholder.fullname')}
                        maxLength={30}
                        autoFocus
                    />
                    <FieldTip>{t('FieldTip.title')}</FieldTip>
                </>
            )}
        </CardEditForm>
    );
}
